import React from 'react';
import { WelcomeLogo } from '@components/molecules/WelcomeLogo';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/Typography';
import styles from './NotFound.module.css';

export const NotFound = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <WelcomeLogo isVisible={true} />
            <div className={styles.message}>
                <Typography fontWeight="400" fontSize="16" align="center" color="light">
                    {t('not-found.unavailable-service')}
                </Typography>
            </div>
        </div>
    );
};
